import { z } from 'zod';
import { AiAdvanceValidationError } from '../../ai-platform/ports.js';
export const CDLIT_BOOKING_CLIENT_PAYLOAD_TTL_HOURS = 24;
export const cdlitAiBookingAttemptStatusSchema = z.enum([
    'draft',
    'ready_to_confirm',
    'creating',
    'confirmed',
    'slot_conflict',
    'failed',
    'expired',
]);
export const cdlitBookingFailureCodeSchema = z.enum([
    'slot_conflict',
    'booking_routing_unconfigured',
    'booking_write_not_verified',
    'booking_not_enabled',
    'validation_error',
    'upstream_unavailable',
    'booking_outcome_unknown',
]);
export const cdlitBookingSelectionSchema = z
    .object({
    serviceExternalId: z.string().min(1).max(64),
    staffExternalId: z.string().min(1).max(64),
    slotStartAt: z.string().datetime(),
})
    .strict();
export const cdlitBookingClientInputSchema = z
    .object({
    fullname: z.string().min(1).max(200),
    phone: z.string().min(5).max(32),
    email: z.string().email().max(200).optional(),
})
    .strict();
export const cdlitBookingClientAgreementsSchema = z
    .object({
    isPersonalDataProcessingAllowed: z.boolean(),
    isNewsletterAllowed: z.boolean().optional(),
})
    .strict();
export const cdlitBookingConfirmationViewSchema = z
    .object({
    serviceTitle: z.string().min(1).max(200),
    staffTitle: z.string().min(1).max(200),
    slotStartAt: z.string().datetime(),
})
    .strict();
export const cdlitBookingAttemptPublicViewSchema = z
    .object({
    attemptId: z.string().uuid(),
    status: cdlitAiBookingAttemptStatusSchema,
    expiresAt: z.string().datetime(),
    failureCode: cdlitBookingFailureCodeSchema.nullable().optional(),
    confirmation: cdlitBookingConfirmationViewSchema.optional(),
})
    .strict();
export const cdlitBookingPrepareRequestSchema = z
    .object({
    idempotencyKey: z.string().min(8).max(128),
})
    .strict();
export const cdlitBookingConfirmRequestSchema = z
    .object({
    client: cdlitBookingClientInputSchema,
    phoneConfirmationCode: z.string().min(4).max(16).optional(),
    clientAgreements: cdlitBookingClientAgreementsSchema.optional(),
})
    .strict();
export const CDLIT_BOOKING_FORBIDDEN_BODY_FIELDS = [
    'productKey',
    'tenantKey',
    'bookingCompanyId',
    'companyId',
    'yclientsRecordId',
    'systemPrompt',
    'safeSummary',
    'transcript',
    'diagnosis',
    'medication',
    'sessionId',
    'selection',
    'serviceExternalId',
    'staffExternalId',
    'slotStartAt',
    'serviceId',
    'staffId',
    'slot',
    'staffTitle',
    'serviceTitle',
    'staffDisplayName',
];
export function assertNoForbiddenBookingBodyFields(body) {
    if (body == null || typeof body !== 'object' || Array.isArray(body))
        return;
    for (const key of CDLIT_BOOKING_FORBIDDEN_BODY_FIELDS) {
        if (key in body) {
            throw new AiAdvanceValidationError(`Field ${key} is not allowed`);
        }
    }
}
export class CdlitBookingError extends Error {
    constructor(code, message) {
        super(message ?? code);
        this.code = code;
        this.name = 'CdlitBookingError';
    }
}
/** Typed adapter failure — distinct from generic upstream_unavailable. */
export class CdlitBookingAdapterError extends Error {
    constructor(kind, message) {
        super(message ?? kind);
        this.kind = kind;
        this.name = 'CdlitBookingAdapterError';
    }
}
//# sourceMappingURL=booking.js.map